import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  username: "",
  role: "",
  user_id: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.username = action.payload.username;
      state.user_id = action.payload.user_id;
      state.role = action.payload.role;
    },
    logout: (state) => {
      state.username = "";
      state.isTripLeader = false;
    },
  },
});

export const { login, logout } = authSlice.actions;

export default authSlice.reducer;
